// ** Icon Registry
// Centralne miejsce zarządzania wszystkimi ikonami

import { eyeIcons } from "./eyeIcons";
import { heartIcons } from "./heartIcons";
import { caretIcons } from "./caretIcons";
import { angleIcons } from "./angleIcons";
import { barsIcons } from "./barsIcons";
import { bellIcons } from "./bellIcons";
import { searchIcons } from "./searchIcons";
import { commentIcons } from "./commentIcons";
import { banIcons } from "./banIcons";
import { paperPlaneIcons } from "./paperPlaneIcons";
import { checkIcons } from "./checkIcons";
import { exchangeIcons } from "./exchangeIcons";
import { thIcons } from "./thIcons";
import { squareIcons } from "./squareIcons";
import { listIcons } from "./listIcons";
import { penIcons } from "./penIcons";
import { plusIcons } from "./plusIcons";
import { arrowIcons } from "./arrowIcons";
import { compressIcons } from "./compressIcons";
import { expandIcons } from "./expandIcons";
import { folderIcons } from "./folderIcons";
import { trashIcons } from "./trashIcons";

export const iconRegistry = {
	...eyeIcons,
	...heartIcons,
	...caretIcons,
	...angleIcons,
	...barsIcons,
	...bellIcons,
	...searchIcons,
	...commentIcons,
	...banIcons,
	...paperPlaneIcons,
	...checkIcons,
	...exchangeIcons,
	...thIcons,
	...squareIcons,
	...listIcons,
	...penIcons,
	...plusIcons,
	...arrowIcons,
	...compressIcons,
	...expandIcons,
	...folderIcons,
	...trashIcons,
};

// #####################################################

// Helper function do sprawdzania czy ikona istnieje
export const hasIcon = (iconName, variant = "solid") => {
	return iconRegistry[iconName] && iconRegistry[iconName].variants[variant];
};

// Helper function do pobierania danych ikony
export const getIconData = (iconName, variant = "solid") => {
	if (!hasIcon(iconName, variant)) {
		console.warn(
			`Icon "${iconName}" with variant "${variant}" not found in registry`,
		);
		return null;
	}

	return {
		viewBox: iconRegistry[iconName].viewBox,
		path: iconRegistry[iconName].variants[variant].path,
	};
};

// #####################################################

export default iconRegistry;

// #####################################################
